import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Subscription, timer } from 'rxjs';

import { MaintenanceService } from '../../../shared/services/maintenance.service';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-maintenance',
    templateUrl: './maintenance.component.html',
    styleUrls: ['./maintenance.component.css'],
    standalone: true,
    imports: [CommonModule]
})
export class MaintenanceComponent implements OnInit, OnDestroy {

    autoCheckInterval = 20000; // 20 segundos
    private autoCheckSubscription: Subscription | null = null;
    private isChecking = false;

    constructor(
        private router: Router,
        private maintenanceService: MaintenanceService,
        private http: HttpClient
    ) { }

    ngOnInit(): void {

        if (!this.maintenanceService.isMaintenanceMode()) {
            this.router.navigate(['/']);
            return;
        }

        this.startAutoCheck();
    }

    ngOnDestroy(): void {
        this.stopAutoCheck();
    }

    reloadPage(): void {
        window.location.reload();
    }

    private checkApiStatus(): void {
        if (this.isChecking) {
            return;
        }

        this.isChecking = true;
        const statusUrl = `${environment.API_URL}status?noLoader=true`;

        // Timeout de 10 segundos
        const timeout = setTimeout(() => {
            this.isChecking = false;
        }, 10000);

        this.http.get<any>(statusUrl, { observe: 'response' }).subscribe({
            next: (response) => {
                clearTimeout(timeout);
                this.isChecking = false;

                // Se a API respondeu com status 200, não está mais em manutenção
                if (response.status === 200) {
                    this.maintenanceService.deactivateMaintenanceMode();

                    setTimeout(() => {
                        this.router.navigate(['/']);
                    }, 100);
                }
            },
            error: (error: HttpErrorResponse) => {
                clearTimeout(timeout);
                this.isChecking = false;

                // Se não é 503 com maintenance: true, pode estar disponível
                if (error.status !== 503 || (error.error && error.error.maintenance !== true)) {
                    // Se não é erro de manutenção, tenta desativar e redirecionar
                    if (error.status === 200 || (error.status !== 503)) {
                        this.maintenanceService.deactivateMaintenanceMode();
                        setTimeout(() => {
                            this.router.navigate(['/']);
                        }, 100);
                    }
                }
            }
        });
    }

    private startAutoCheck(): void {
        if (this.autoCheckSubscription) {
            return;
        }

        // Primeira checagem após 5 segundos
        setTimeout(() => {
            this.checkApiStatus();
        }, 5000);

        // Depois, checa a cada intervalo configurado
        this.autoCheckSubscription = timer(this.autoCheckInterval, this.autoCheckInterval).subscribe(() => {
            if (this.maintenanceService.isMaintenanceMode() && !this.isChecking) {
                this.checkApiStatus();
            } else if (!this.maintenanceService.isMaintenanceMode()) {
                this.stopAutoCheck();
            }
        });
    }

    private stopAutoCheck(): void {
        if (this.autoCheckSubscription) {
            this.autoCheckSubscription.unsubscribe();
            this.autoCheckSubscription = null;
        }
    }

}

